<template>
  <el-dialog
    title="添加配件"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form :model="model" :rules="rules" ref="form" size="small">
      <el-form-item label="" prop="item_id" class="long">
        <ItemSelect
          v-model="model.item_id"
          :status="1"
          :category="model.category"
          :singleSelect="true"
          :install="true"
        ></ItemSelect>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { productItemNew } from '@/service/getData'

import ItemSelect from '@/components/select/item_select'

export default {
  components: {
    ItemSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      loading: false,
      pdcs: [],
      rules: {
        item_id: [{ required: true, message: '请选择配件', trigger: 'change' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          let res = await productItemNew(data)
          if (res.status == 0) {
            this.$emit('created', res.data)
            this.visible = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>